import { Pipe, PipeTransform } from '@angular/core';

const LABEL_KEYS: { [sourceType: string]: string } = {
  Manual: 'UAV_SOURCE_MANUAL',
  Ftp: 'UAV_SOURCE_FTP',
  Api: 'UAV_SOURCE_API',
};

@Pipe({
  name: 'uavSourceTypeLabel',
  standalone: true,
})
export class UavSourceTypeLabelPipe implements PipeTransform {
  transform(sourceType: string | null | undefined): string {
    if (!sourceType) {
      return LABEL_KEYS['Manual'];
    }
    return LABEL_KEYS[sourceType] || sourceType;
  }
}
